<div class="dialog">
  <ng-lottie [options]="{ path: '/assets/animations/product-icons/pro.json' }"></ng-lottie>
  <h1>RAW Upload</h1>

  <p>Upgrade your plan for RAW uploading and to unlock other premium features.</p>

  <a
    [routerLink]="['/a', 'pricing']"
    [queryParams]="{ product: 'pro' }"
    appButton
    name="confirm"
    location="raw-upload-paywall-dialog"
    color="primary"
    shape="round"
    height="4"
    spacing="4"
    size="3"
    [center]="true"
  >
    Upgrade to Pro
  </a>
</div>
